module.exports = __webpack_public_path__ + "static/media/icon-backup-cloud.eb040d8c.svg";